export default __webpack_public_path__ + "static/media/GL.2e7586ca.ico";